export default {
    methods: {
        showLoader() {
            return this.$loading.show({
                container: this.fullPage ? null : this.$refs.formContainer,
                canCancel: false,
                onCancel: this.onCancel,
            });
        }
    },
};